<section
  #surface
  class="np"
  role="dialog"
  aria-labelledby="notification-panel-title"
  tabindex="-1"
>
  <header class="np-head">
    @if (compact()) {
      <!-- M3 full-screen pattern on a phone: Close at the leading edge of the header (no Escape key there). -->
      <button
        matIconButton
        matExpIconButton
        type="button"
        class="np-options"
        aria-label="Close notifications"
        (click)="closeRequested.emit()"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    } @else {
      <span aria-hidden="true"></span>
    }
    <h2 id="notification-panel-title">Notifications</h2>
    <button
      matIconButton
      matExpIconButton
      type="button"
      class="np-options"
      aria-label="Notification options"
      [matMenuTriggerFor]="options"
    >
      <mat-icon aria-hidden="true">more_vert</mat-icon>
    </button>
    <mat-menu #options="matMenu" xPosition="before">
      <button
        mat-menu-item
        type="button"
        [disabled]="!canMarkAllRead()"
        (click)="markAllRead()"
      >
        <mat-icon aria-hidden="true">done_all</mat-icon>
        <span>Mark all as read</span>
      </button>
      <button
        mat-menu-item
        type="button"
        [disabled]="!canClearAll()"
        (click)="clearAll()"
      >
        <mat-icon aria-hidden="true">clear_all</mat-icon>
        <span>Clear all</span>
      </button>
      @if (emailEnabled()) {
        <a mat-menu-item routerLink="/notifications/email-settings">
          <mat-icon aria-hidden="true">tune</mat-icon>
          <span>Email preferences</span>
        </a>
      }
    </mat-menu>
  </header>

  <div #list class="np-list">
    @if (inbox.panelError()) {
      <div class="np-empty" role="alert">
        <p>Notifications didn't load. Your saved history is safe.</p>
        <button
          matButton="filled"
          matExpButton
          type="button"
          (click)="inbox.refresh()"
        >
          Retry
        </button>
      </div>
    } @else if (rows() === null) {
      <div class="np-loading" aria-busy="true">
        <mat-exp-loading-indicator ariaLabel="Loading notifications" />
      </div>
    } @else if (!rows()!.length) {
      <div class="np-empty" data-slot="empty">
        <mat-icon aria-hidden="true">notifications</mat-icon>
        <p class="np-empty-title">No notifications</p>
        <p>
          New notices appear here. Notices you dismiss stay in Notifications,
          under Dismissed.
        </p>
      </div>
    } @else {
      @for (item of rows(); track item.id) {
        <syrf-notification-card
          [notification]="item"
          [expanded]="expandedId() === item.id"
          [busy]="isBusy(item.id)"
          [now]="now()"
          [compact]="compact()"
          [panel]="true"
          (toggled)="toggle(item)"
          (readChanged)="setRead(item, $event)"
          (dismissed)="dismiss(item)"
          (answered)="answer(item, $event)"
        />
      }
    }
  </div>

  <footer class="np-foot">
    <a
      matButton="outlined"
      matExpButton
      data-action="see-all"
      [routerLink]="seeAllLink()"
      >See all in Notifications</a
    >
  </footer>
</section>
